import { render, staticRenderFns } from "./InternDeprecated.vue?vue&type=template&id=65baa86b&scoped=true"
import script from "./InternDeprecated.vue?vue&type=script&lang=js"
export * from "./InternDeprecated.vue?vue&type=script&lang=js"
import style0 from "./InternDeprecated.vue?vue&type=style&index=0&id=65baa86b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baa86b",
  null
  
)

export default component.exports